<template>
    <el-header class="text-left header" v-click-outside="hideDropDownButton" @click="hideDropDownButton">
        <div id="header_with_none_mobile">
            <el-button id="home_button" class="button" @click="toHome">ホーム</el-button>
            <label>ちゅらネット予約</label>

            <div class="pull-right">

                <label v-if="isAuth" id="username">{{username}}</label>

                <el-button v-if="isAuth" id="my_page_button" class="button" @click="myPage">{{$t('common.myPage')}}
                </el-button>
                <el-button v-if="!isAuth" class="button" id="login_button" @click="toLogin">{{$t('common.login')}}
                </el-button>

                <el-button v-if="isAuth" id="logout_button" class="button" @click="logout">{{$t('common.logout')}}
                </el-button>

            </div>
        </div>

        <div id="header_with_tablet" style="height: 70px">
            <el-button class="button" style="" @click="toHome">ホーム</el-button>
            <label>ちゅらネット予約</label>

            <div class="pull-right">
                <div style="height: 30px;">
                    <label v-if="isAuth">{{username}}</label>
                    <el-button v-if="!isAuth" class="button" style="margin-right: 0; margin-top: 0" @click="toLogin">
                        {{$t('common.login')}}
                    </el-button>
                </div>

                <div style="height: 35px; margin-bottom: 0px; text-align: right">
                    <el-button v-if="isAuth" class="button" style="margin-top: 0" @click="myPage">
                        {{$t('common.myPage')}}
                    </el-button>

                    <el-button v-if="isAuth" class="button" style="margin-right: 0; margin-top: 0" @click="logout">
                        {{$t('common.logout')}}
                    </el-button>
                </div>

            </div>
        </div>

        <div id="header_with_mobile">
            <el-row class="row" style="height: 35px; position: relative">
                <div style="float: left; text-align: left; width: 40px; padding-top: 5px; margin-top: 10px;">
                    <el-button @click="triggerDropDownButton" v-click-outside="hideDropDownButton" icon="menu_button"
                               style="background-color: #4B86E8; border: none; color: white; width: 26px; height: 26px; position: relative">
                        <img id="menu_icon" src="../../assets/images/icons/menu_icon.png">
                    </el-button>
                    <div class="dropdown-button" v-bind:style="dropMenuStyle" style="margin-top: 10px;">
                        <el-link class="group_button" @click="toHome">ホーム</el-link>
                        <el-link v-if="!isAuth" class="group_button" @click="toLogin">{{$t('common.login')}}</el-link>
                        <el-link v-if="isAuth" class="group_button" @click="myPage">マイページ</el-link>
                        <el-link v-if="isAuth" class="group_button" @click="logout">{{$t('common.logout')}}</el-link>
                    </div>
                </div>
                <label style="margin-top: 25px;font-size: 14px;">ちゅらネット予約</label>

            </el-row>

            <el-row class="right-block" @click="hideDropDownButton">
                <div @click="hideDropDownButton" class="username">
                    <label v-if="isAuth">{{username}}</label>
                </div>
                <el-link v-if="isAuth" class="button-mypage" @click="myPage">マイページ</el-link>
                <el-button v-if="!isAuth" class="button" style="margin-top: 10px;margin-right: 5px;" @click="toLogin">
                    {{$t('common.login')}}
                </el-button>
            </el-row>
        </div>
    </el-header>
</template>

<script>
    import i18n from '@/i18n';
    import auth from "@/security/Authentication";
    import Pages from '@/router/Pages';

    export default {
        name: "Header",
        props: [],
        data() {
            return {
                currentLang: i18n.getCurrentLang(),
                isAuth: auth.isAuthenticated(),
                username: "",
                dropMenuStyle: {
                    display: 'none',
                }
            }
        },
        created() {
            this.dropMenuStyle.display = "none";
        },

        mounted() {
            this.dropMenuStyle.display = "none";
            this.isAuth = auth.isAuthenticated();
            if (this.isAuth) {
                this.username = auth.getCurrentUser().username;
            }
        },
        computed: {
            isEnglish: function () {
                return this.currentLang == "en";
            },
            isJapanese: function () {
                return this.currentLang == "jp";
            },
        },
        watch: {
            '$route'() {
                this.isAuth = auth.isAuthenticated();
                if (this.isAuth) {
                    this.username = auth.getCurrentUser().username;
                }
            }
        },
        methods: {
            toLogin() {
                this.$router.push({path: Pages.login.path});
            },
            toHome() {
                this.$router.push({path: Pages.home.path});
                this.dropMenuStyle.display = "none"
            },
            logout() {
                auth.logout();
                this.isAuth = false;
                this.$router.push({path: "/login"});
                this.dropMenuStyle.display = "none"
            },
            switchLang(){
                let lang = this.currentLang == "en"  ? "jp" : "en";
                this.changeLang(lang);
            },
            changeLang(lang) {
                this.currentLang = lang;
                i18n.changeLang(lang);
                window.location.reload();
            },
            myPage() {
                this.$router.push({path: "/myPage"});
                this.dropMenuStyle.display = "none"
            },

            triggerDropDownButton() {
                if (this.dropMenuStyle.display == "none") {
                    this.dropMenuStyle.display = "block"
                } else {
                    this.dropMenuStyle.display = "none"
                }
            },

            hideDropDownButton() {
                this.dropMenuStyle.display = "none"
                console.log()
            }
        },

        directives: {
            'click-outside': {
                bind: function (el, binding, vNode) {
                    // Provided expression must evaluate to a function.
                    if (typeof binding.value !== 'function') {
                        const compName = vNode.context.name
                        let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                        if (compName) {
                            warn += `Found in component '${compName}'`
                        }

                        console.warn(warn)
                    }
                    // Define Handler and cache it on the element
                    const bubble = binding.modifiers.bubble
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target)) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler

                    // add Event Listeners
                    document.addEventListener('click', handler)
                },

                unbind: function (el, binding) {
                    // Remove Event Listeners
                    document.removeEventListener('click', el.__vueClickOutside__)
                    el.__vueClickOutside__ = null

                }
            }
        }
    };
</script>

<style scoped lang="scss">

    #header_with_mobile {
        display: none;
        position: relative;

        .right-block {
            height: 35px;
            position: absolute;
            float: right;
            top: 0;
            right: 0;
            font-size: 13px;

            .username {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-top: 10px
            }
            .button-logout,.button-mypage {
                display: inline-block;
                border: 1px solid white;
                padding: 0px 15px;
                color: white;
                position: absolute;
                right: 0px;
            }
            .button-mypage{
                width: 75px;
            }
        }

        #menu_icon {
            width: 40px;
            left: -4px;
            top: -3px;
            position: absolute
        }
    }

    #header_with_tablet {
        display: none;
    }

    #logout_button, #login_button, #my_page_button {
        margin-right: 10px;
    }

    #username {
        margin-right: 30px;
        font-size: 90%;
    }

    .header {
        height: 50px;
    }

    .link {
        margin: 0 10px;
    }

    .el-dropdown {
        margin-left: 10px;
    }

    .el-icon-setting {
        margin-right: 15px
    }

    .el-header {
        background-color: #4B86E8;
        color: #ffff;
        line-height: 50px;
    }

    .header .button {
        background-color: #4B86E8;
        color: #ffffff;
        padding: 5px 30px;
        border: 1px solid #ffffff;
        cursor: pointer;
        border-radius: 0;
        min-width: 125px;
        margin-right: 20px;
    }

    .pull-right {
        float: right;
    }

    .logout {
        color: #ffff;
    }

    .change-lang, .logout, .change-pass {
        text-decoration: underline;
        margin-left: 10px;
        cursor: pointer;
    }

    @media only screen and (max-width: 1023px) {
        #header_with_none_mobile {
            display: none;
        }

        #header_with_mobile {
            display: none;
        }
        #header_with_tablet {
            display: block;
        }

        .header {
            height: 70px !important;
        }
    }

    @media only screen and (max-width: 750px) {
        #header_with_none_mobile {
            display: none;
        }

        #header_with_mobile {
            display: block;
        }
        #header_with_tablet {
            display: none;
        }

        #home_button {
            width: 50px !important;
            max-width: 20%
        }

        .header .button {
            background-color: #4B86E8;
            color: #ffffff;
            border: 1px solid #ffffff;
            cursor: pointer;
            border-radius: 0;
        }

        .header {
            height: 70px !important;
        }

        .el-header {
            line-height: 22px;
        }

        .dropdown-button {
            .group_button {
                height: 30px;
                background-color: #4B86E8;
                z-index: 100;
                width: 100px;
                text-align: left;
                color: white;
                border-top: 1px solid white;
            }
        }
    }
</style>
